<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { get } from "lodash";
import StripeHeader from "stripe-header";

export default {
  mixins: [fandomBasicMixin],
  components: {
    StripeHeader
  },
  mounted() {
    this.registerAnimation();
  },
  computed: {
    columnClass() {
      const classes = [];
      const defaultClass = this.content.column_count ? `col-lg-${12/this.content.column_count}` : "col-lg-4";

      switch(parseInt(this.content.skin)) {
        case 1:
          classes.push(defaultClass);
          break;
        case 2:
          classes.push("col-md-6 col-12");
          break;
        default:
          classes.push(defaultClass);
      }
      return classes;
    },
    widthClass() {
      return this.content.width ? `col-lg-${this.content.width}` : "col-lg-8";
    }
  },
  methods: { 
    getWrapperTag(point) {
      return Fandom.exists(point.url) ? "a" : "div";
    },
    getPointUrl(point) {
      return Fandom.exists(point.url) ? point.url.url : null;
    },
    getPointTitle(point) {
      return get(point, ["url", "title"], null); 
    },
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTarget: Fandom.getTarget,
    getPrimaryButtonClass: Fandom.getPrimaryButtonClass
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" class="inview_animate py-4" :class="contentType" v-if="isContentVisibleToUser()" list-keypoint-component :style="{'background-color': content.background_color}">
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <div class="container py-4">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center" v-if="content.title || content.description || content.category">
          <stripe-header :content="content"></stripe-header>
        </div>
        <div :class="widthClass">
          <div class="row justify-content-center">
            <component 
              v-for="(point, index) in content.keypoint" 
              :key="index" 
              class="col-6 px-4 my-4" 
              :is="getWrapperTag(point)" 
              :href="getPointUrl(point)" 
              :title="getPointTitle(point)" 
              :target="getTarget(point.url)" 
              :class="[columnClass, {'has-url': point.url}, `text-${content.text_align ? content.text_align : 'center'}`]"
            >
              <h3 v-if="point.amount" class="display-2">{{point.amount}}</h3>
              <div 
                v-if="point.image" 
                class="point-image my-4" 
                :class="[`m${content.text_align == 'left' ? 'r' : content.text_align == 'right' ? 'l' : 'x'}-auto`]"
              >
                <div v-if="!content.no_mask_image" class="bg-cover-center ar-1by1 w-100" :class="{'rounded-circle': !content.squared_images}" :style="{'background-image': getBackgroundUrl(point.image.url)}"></div>
                <img class="w-100" :src="point.image.url" v-else>
              </div>
              <h4 class="text-uppercase mb-2 text-dark" v-if="point.title">{{point.title}}</h4>
              <p class="mb-2"><small class="font-weight-bold text-dark" v-if="point.subtitle">{{point.subtitle}}</small></p>
              <p v-if="point.description"><small class="text-dark" v-html="point.description"></small></p>
              <div v-if="point.button">
                <a class="btn shadow-none my-3" :class="getPrimaryButtonClass(point.button_class)" :href="point.button.url" :target="getTarget(point.button)">
                  <i :class="point.button_icon" class="mx-2" v-if="point.button_icon"></i>
                  {{point.button.title}}
                </a>
              </div>
            </component> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[list-keypoint-component] {
  .dark-theme & {
    .text-dark {
      color: $white !important;
    }
  }

  h4 {
    letter-spacing: 1.2px;
  }

  .point-image {
    width: 8rem;
    max-width: 100%;
  }

  .rounded-circle {
    border-radius: 100%;
  }
}

</style>
